import React from 'react';
import { X } from '@phosphor-icons/react';
import { AnalyzerWeeklyPrompt } from '@Models/types';

interface ViewPromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  prompt: AnalyzerWeeklyPrompt | null;
  isAdmin: boolean;
  onEdit: (prompt: AnalyzerWeeklyPrompt) => void;
  onDelete: (prompt: AnalyzerWeeklyPrompt) => void;
  onSetDefault: (prompt: AnalyzerWeeklyPrompt) => void;
  currentDefaultPrompt: AnalyzerWeeklyPrompt | null;
}

export const ViewPromptModal: React.FC<ViewPromptModalProps> = ({
  isOpen,
  onClose,
  prompt,
  isAdmin,
  onEdit,
  onDelete,
  onSetDefault,
  currentDefaultPrompt,
}) => {
  if (!isOpen || !prompt) return null;

  const isCurrentDefault =
    currentDefaultPrompt?.promptTitle === prompt.promptTitle &&
    currentDefaultPrompt?.authorEmail === prompt.authorEmail;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-full max-w-2xl rounded-lg bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-900">
            {prompt.promptTitle}
          </h2>
          <button
            onClick={onClose}
            className="rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            <X size={20} />
          </button>
        </div>

        <div className="mb-4 text-sm text-gray-600">
          <p>Author: {prompt.authorEmail}</p>
          <p>Created: {new Date(prompt.dateCreated).toLocaleDateString()}</p>
          {prompt.isDefault && (
            <p className="font-medium text-green-600">Default Prompt</p>
          )}
        </div>

        <div className="max-h-[60vh] overflow-auto whitespace-pre-wrap rounded border p-3 text-sm">
          {prompt.promptString}
        </div>

        <div className="mt-4 flex justify-end gap-3">
          {isAdmin && (
            <>
              <button
                onClick={() => onEdit(prompt)}
                className="rounded-md border px-4 py-2 text-sm"
              >
                Edit
              </button>
              {!prompt.isDefault && (
                <button
                  onClick={() => onDelete(prompt)}
                  className="rounded-md border border-red-300 bg-red-50 px-4 py-2 text-sm text-red-700"
                >
                  Delete
                </button>
              )}
              {!isCurrentDefault && (
                <button
                  onClick={() => onSetDefault(prompt)}
                  className="rounded-md bg-green-600 px-4 py-2 text-sm text-white"
                >
                  Set as Default
                </button>
              )}
            </>
          )}
          <button
            onClick={onClose}
            className="rounded-md bg-primary-600 px-4 py-2 text-sm text-white"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
